import React, { useState, useMemo } from 'react';
import { Card, Table, Form, Row, Col, Badge, ProgressBar, Spinner, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import Select from 'react-select';
import { LICHHUONGDANTHUCHANH_API, DONVI_API } from '../../../../utils/apiUrl';
import { Get } from '../../../../utils/httpProvider';

const ThongKeDiemDanhThucHanh = ({ lopId }) => {
    const [selectedDonViId, setSelectedDonViId] = useState('');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [filterStatus, setFilterStatus] = useState('ALL'); // 'ALL' | 'DAT' | 'THIEU'

    // 1. Fetch danh sách khoa
    const { data: donViList = [] } = useQuery(
        'donViListThucHanhThongKe',
        () => Get(DONVI_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        {
            select: (res) => res?.data?.data || res?.data || res || []
        }
    );

    // 2. Fetch dữ liệu thống kê
    const { data: summaryData, isLoading, refetch } = useQuery(
        ['thongKeDiemDanhThucHanh', lopId, selectedDonViId, searchKeyword],
        async () => {
            let url = `${LICHHUONGDANTHUCHANH_API.GET_THONG_KE_DIEM_DANH}/${lopId}`;
            const params = [];
            if (selectedDonViId) params.push(`donViId=${selectedDonViId}`);
            if (searchKeyword) params.push(`keyword=${encodeURIComponent(searchKeyword)}`);
            if (params.length > 0) url += `?${params.join('&')}`;

            const res = await Get(url);
            return res?.data || res || {};
        },
        {
            enabled: !!lopId,
            keepPreviousData: true
        }
    );

    const items = summaryData?.items?.$values || summaryData?.items || [];

    // Filter items theo Trạng thái Đạt / Thiếu ngày trên frontend
    const filteredItems = useMemo(() => {
        if (filterStatus === 'DAT') {
            return items.filter(x => x.trangThaiHoanThanh === 1);
        }
        if (filterStatus === 'THIEU') {
            return items.filter(x => x.trangThaiHoanThanh === 2);
        }
        return items;
    }, [items, filterStatus]);

    return (
        <div className="thong-ke-diem-danh-thuc-hanh">
            {/* KHỐI 1: KPI CARDS */}
            <Row className="mb-4" style={{ rowGap: '12px' }}>
                <Col xl={3} lg={6} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #e0f2fe 0%, #f0f9ff 100%)', borderLeft: '5px solid #0284c7' }}>
                        <Card.Body className="p-3 d-flex align-items-center justify-content-between">
                            <div>
                                <div className="text-muted small font-weight-bold text-uppercase">Tổng học viên</div>
                                <div className="h3 mb-0 font-weight-bold" style={{ color: '#0369a1' }}>
                                    {summaryData?.tongHocVien ?? 0}
                                </div>
                                <small className="text-secondary">Trong lớp thực hành</small>
                            </div>
                            <div className="p-3 rounded-circle bg-white shadow-xs">
                                <i className="fas fa-user-graduate fa-2x" style={{ color: '#0284c7' }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={3} lg={6} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #f3e8ff 0%, #faf5ff 100%)', borderLeft: '5px solid #9333ea' }}>
                        <Card.Body className="p-3 d-flex align-items-center justify-content-between">
                            <div>
                                <div className="text-muted small font-weight-bold text-uppercase">Khoa thực hành</div>
                                <div className="h3 mb-0 font-weight-bold" style={{ color: '#7e22ce' }}>
                                    {summaryData?.soKhoaThucHanh ?? 0}
                                </div>
                                <small className="text-secondary">Đã phân công lịch</small>
                            </div>
                            <div className="p-3 rounded-circle bg-white shadow-xs">
                                <i className="fas fa-hospital fa-2x" style={{ color: '#9333ea' }}></i>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={2} lg={4} sm={4}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #e0e7ff 0%, #eef2ff 100%)', borderLeft: '5px solid #4f46e5' }}>
                        <Card.Body className="p-3">
                            <div className="text-muted small font-weight-bold text-uppercase">Tỷ lệ TB</div>
                            <div className="h3 mb-0 font-weight-bold" style={{ color: '#4338ca' }}>
                                {summaryData?.tyLeHoanThanhTrungBinh ?? 0}%
                            </div>
                            <ProgressBar 
                                now={summaryData?.tyLeHoanThanhTrungBinh ?? 0} 
                                variant={summaryData?.tyLeHoanThanhTrungBinh >= 80 ? 'success' : 'warning'} 
                                style={{ height: '5px', marginTop: '8px' }} 
                            />
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={2} lg={4} sm={4}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%)', borderLeft: '5px solid #16a34a' }}>
                        <Card.Body className="p-3">
                            <div className="text-muted small font-weight-bold text-uppercase">Đạt yêu cầu</div>
                            <div className="h3 mb-0 font-weight-bold" style={{ color: '#15803d' }}>
                                {summaryData?.soHocVienDat ?? 0}
                            </div>
                            <small className="text-success font-weight-bold">Đủ ngày theo quy định</small>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xl={2} lg={4} sm={4}>
                    <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px', background: 'linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%)', borderLeft: '5px solid #dc2626' }}>
                        <Card.Body className="p-3">
                            <div className="text-muted small font-weight-bold text-uppercase">Chưa đạt / Thiếu</div>
                            <div className="h3 mb-0 font-weight-bold" style={{ color: '#b91c1c' }}>
                                {summaryData?.soHocVienChuaDat ?? 0}
                            </div>
                            <small className="text-danger font-weight-bold">Cần hoàn thành thêm</small>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* KHỐI 2: TOOLBAR LỌC & TÌM KIẾM */}
            <Card className="shadow-sm border-0 mb-3" style={{ borderRadius: '12px' }}>
                <Card.Body className="py-2 px-3">
                    <Row className="align-items-center">
                        <Col xl={4} lg={4} md={6} className="my-1">
                            <div className="d-flex align-items-center">
                                <i className="fas fa-search text-muted mr-2"></i>
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    placeholder="Tìm theo tên học viên, đơn vị..."
                                    value={searchKeyword}
                                    onChange={(e) => setSearchKeyword(e.target.value)}
                                    style={{ borderRadius: '8px', border: '1px solid #cbd5e1' }}
                                />
                            </div>
                        </Col>

                        <Col xl={3} lg={3} md={6} className="my-1">
                            <Select
                                isClearable
                                placeholder="-- Lọc theo Khoa --"
                                options={donViList.map(dv => ({
                                    value: dv.id,
                                    label: dv.tenDonVi || dv.ten || dv.name || dv.maDonVi || 'Khoa'
                                }))}
                                value={selectedDonViId ? {
                                    value: selectedDonViId,
                                    label: donViList.find(d => d.id === selectedDonViId)?.tenDonVi || selectedDonViId
                                } : null}
                                onChange={(opt) => setSelectedDonViId(opt ? opt.value : '')}
                                styles={{
                                    control: (base) => ({ ...base, minHeight: 32, height: 32, fontSize: '13px', borderRadius: '8px', borderColor: '#cbd5e1' }),
                                    valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                                    indicatorsContainer: (base) => ({ ...base, height: 32 })
                                }}
                            />
                        </Col>

                        <Col xl={3} lg={3} md={6} className="my-1">
                            <div className="btn-group btn-group-sm w-100" role="group">
                                <Button
                                    variant={filterStatus === 'ALL' ? 'primary' : 'outline-secondary'}
                                    style={{ borderRadius: '8px 0 0 8px', fontSize: '12px' }}
                                    onClick={() => setFilterStatus('ALL')}
                                >
                                    Tất cả ({items.length})
                                </Button>
                                <Button
                                    variant={filterStatus === 'DAT' ? 'success' : 'outline-secondary'}
                                    style={{ fontSize: '12px' }}
                                    onClick={() => setFilterStatus('DAT')}
                                >
                                    Đạt ({items.filter(x => x.trangThaiHoanThanh === 1).length})
                                </Button>
                                <Button
                                    variant={filterStatus === 'THIEU' ? 'danger' : 'outline-secondary'}
                                    style={{ borderRadius: '0 8px 8px 0', fontSize: '12px' }}
                                    onClick={() => setFilterStatus('THIEU')}
                                >
                                    Thiếu ({items.filter(x => x.trangThaiHoanThanh === 2).length})
                                </Button>
                            </div>
                        </Col>

                        <Col xl={2} lg={2} md={6} className="my-1 text-right">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                style={{ borderRadius: '8px', fontSize: '12px' }}
                                onClick={() => refetch()}
                                title="Tải lại dữ liệu"
                            >
                                <i className="fas fa-sync-alt mr-1"></i> Làm mới
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* KHỐI 3: BẢNG MATRIX THỐNG KÊ */}
            <Card className="shadow-sm border-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 350px)', overflowY: 'auto' }}>
                    <Table hover className="mb-0 align-middle" style={{ minWidth: 1000 }}>
                        <thead style={{ backgroundColor: '#f8fafc', position: 'sticky', top: 0, zIndex: 2, boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                            <tr style={{ color: '#475569', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                <th style={{ width: 50, textAlign: 'center' }}>STT</th>
                                <th style={{ minWidth: 200 }}>Học viên</th>
                                <th style={{ minWidth: 180 }}>Khoa & Đợt</th>
                                <th style={{ width: 90, textAlign: 'center' }}>Quy định</th>
                                <th style={{ width: 90, textAlign: 'center', color: '#15803d' }}>Có mặt</th>
                                <th style={{ width: 90, textAlign: 'center', color: '#b45309' }}>Vắng CP</th>
                                <th style={{ width: 90, textAlign: 'center', color: '#b91c1c' }}>Vắng KP</th>
                                <th style={{ width: 80, textAlign: 'center', color: '#0369a1' }}>Học bù</th>
                                <th style={{ width: 140, textAlign: 'center' }}>% Hoàn thành</th>
                                <th style={{ width: 130, textAlign: 'center' }}>Kết luận</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr>
                                    <td colSpan={10} className="text-center py-5">
                                        <Spinner animation="border" variant="primary" size="sm" className="mr-2" />
                                        <span className="text-muted">Đang tải số liệu thống kê điểm danh...</span>
                                    </td>
                                </tr>
                            ) : filteredItems.length === 0 ? (
                                <tr>
                                    <td colSpan={10} className="text-center py-5">
                                        <div className="text-muted">
                                            <i className="fas fa-inbox fa-3x mb-3 text-secondary" style={{ opacity: 0.5 }}></i>
                                            <p className="mb-0">Không tìm thấy bản ghi thống kê điểm danh phù hợp.</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                filteredItems.map((row, idx) => {
                                    const isDat = row.trangThaiHoanThanh === 1;
                                    const progressVariant = row.tyLeHoanThanh >= 100 ? 'success' : row.tyLeHoanThanh >= 80 ? 'info' : 'warning';

                                    return (
                                        <tr key={`${row.hoSoTuyenSinhId}-${row.donViId}-${idx}`} style={{ fontSize: '13px' }}>
                                            <td className="text-center text-muted font-weight-bold" style={{ verticalAlign: 'middle' }}>
                                                {idx + 1}
                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="font-weight-bold text-dark">{row.hocVienTen}</div>
                                                <div className="small text-muted">
                                                    {row.ngaySinh && <span>NS: {row.ngaySinh}</span>}
                                                    {row.donViCongTac && <span> • {row.donViCongTac}</span>}
                                                </div>
                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="font-weight-500" style={{ color: '#1e293b' }}>
                                                    {row.tenKhoa || "Chưa xác định"}
                                                </div>
                                                {row.ngayDotTuDen && (
                                                    <span className="badge badge-light text-secondary border px-2 py-1 mt-1" style={{ fontSize: '11px', borderRadius: '4px' }}>
                                                        <i className="far fa-calendar-alt mr-1"></i>
                                                        {row.ngayDotTuDen}
                                                    </span>
                                                )}
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle', color: '#334155' }}>
                                                {row.tongNgayQuyDinh} ngày
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle', color: '#16a34a' }}>
                                                {row.soNgayCoMat}
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle', color: '#d97706' }}>
                                                {row.soNgayVangCoPhep > 0 ? row.soNgayVangCoPhep : '-'}
                                            </td>

                                            <td className="text-center font-weight-bold" style={{ verticalAlign: 'middle' }}>
                                                {row.soNgayVangKhongPhep > 0 ? (
                                                    <span className="badge badge-danger px-2 py-1" style={{ fontSize: '12px' }}>
                                                        <i className="fas fa-exclamation-triangle mr-1"></i>
                                                        {row.soNgayVangKhongPhep}
                                                    </span>
                                                ) : (
                                                    <span className="text-muted">-</span>
                                                )}
                                            </td>

                                            <td className="text-center" style={{ verticalAlign: 'middle', color: '#0284c7' }}>
                                                {row.soNgayHocBu > 0 ? row.soNgayHocBu : '-'}
                                            </td>

                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                    <span className="small font-weight-bold" style={{ color: '#475569' }}>
                                                        {row.tyLeHoanThanh}%
                                                    </span>
                                                </div>
                                                <ProgressBar 
                                                    now={Math.min(100, row.tyLeHoanThanh)} 
                                                    variant={progressVariant} 
                                                    style={{ height: '6px', borderRadius: '3px' }} 
                                                />
                                            </td>

                                            <td className="text-center" style={{ verticalAlign: 'middle' }}>
                                                {isDat ? (
                                                    <Badge 
                                                        variant="success" 
                                                        className="px-2 py-1"
                                                        style={{ backgroundColor: '#dcfce7', color: '#15803d', border: '1px solid #86efac', fontSize: '12px', fontWeight: '600' }}
                                                    >
                                                        <i className="fas fa-check-circle mr-1"></i> Đạt
                                                    </Badge>
                                                ) : (
                                                    <Badge 
                                                        variant="danger" 
                                                        className="px-2 py-1"
                                                        style={{ backgroundColor: '#fee2e2', color: '#b91c1c', border: '1px solid #fca5a5', fontSize: '12px', fontWeight: '600' }}
                                                    >
                                                        <i className="fas fa-times-circle mr-1"></i> Thiếu {row.soNgayConThieu} ngày
                                                    </Badge>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card>
        </div>
    );
};

export default ThongKeDiemDanhThucHanh;
